import {Component, inject, ViewEncapsulation} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {HeaderComponent} from './shared/components/header/header.component';
import {FooterComponent} from './shared/components/footer/footer.component';
import {LoadingService} from './shared/services/loading.service';
import {LoaderComponent} from './shared/components/loader/loader.component';
import {AlertMessageComponent} from './shared/components/alert-message/alert-message.component';
import {ConfirmDialogComponent} from './shared/components/confirm-dialog/confirm-dialog.component';
import {AlertService} from './shared/services/alert.service';
import {DeviceService} from './shared/services/device.service';
import {AnalyticsService} from './core/services/analytics.service';
import {NavigationHistoryService} from './core/services/navigation-history.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    AlertMessageComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  protected loadingService: LoadingService = inject(LoadingService);
  protected alertService: AlertService = inject(AlertService);
  deviceService: DeviceService = inject(DeviceService);
  private analyticsService: AnalyticsService = inject(AnalyticsService);
  private navigationHistory: NavigationHistoryService = inject(NavigationHistoryService);
}






